// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3c5ae144","239":"b601137e","455":"a3c0fc0c"}[chunkId] + ".chunk.js";
};